import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RootState } from "../../../globals";
import TableroView from "./tableroView";

/**
 * Tablero de Ventas como sección propia del menú (Esteban, 4-nov-2026: "arriba de CRM y quitarlo de dentro del CRM").
 * Sección 99 (tableroVentas), grupo Ventas; la tiene Supervisión y Dirección. "Volver" lleva al CRM.
 */
const TableroController: React.FC = () => {
	const navigate = useNavigate();
	const sessionCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
	const legacyCampusKey: any = useSelector((state: RootState) => state.currentUserCampus.value);
	const legacyCampusRef: any = useSelector((state: RootState) => state.campusRef.value);
	const legacyCampus: any = legacyCampusKey && legacyCampusRef ? legacyCampusRef[legacyCampusKey] : null;
	const campusId: number | null = legacyCampus?.id ?? sessionCampus?.id ?? null;
	if (!campusId) return null;
	return <div className="crm"><TableroView campusId={campusId} onSalir={() => navigate("/prospects")} /></div>;
};

export default TableroController;
